import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'components/UI';
import { convertToAdditionalCurrency } from 'utils';
import { modalContent, paymentItem, totalAmount } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var ReportPaymentsModal = function ReportPaymentsModal(_ref) {
  var _selectedPayments$;

  var modalRef = _ref.modalRef,
      selectedPayments = _ref.selectedPayments,
      onConfirm = _ref.onConfirm,
      onClose = _ref.onClose;
  var totalSum = selectedPayments.reduce(function (acc, payment) {
    return acc + Number(payment.total_report_amount);
  }, 0);
  var currency = ((_selectedPayments$ = selectedPayments[0]) === null || _selectedPayments$ === void 0 ? void 0 : _selectedPayments$.currency) || 'EUR';
  return ___EmotionJSX(Modal, {
    ref: modalRef,
    onClose: onClose
  }, ___EmotionJSX("div", {
    css: modalContent
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435"), ___EmotionJSX("p", {
    className: "mb1"
  }, ___EmotionJSX("strong", null, "\u0418\u0437\u0431\u0440\u0430\u043D\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F:")), ___EmotionJSX("div", {
    className: "mb1"
  }, selectedPayments.map(function (payment) {
    var _payment$partner;

    return ___EmotionJSX("div", {
      key: payment.id,
      css: paymentItem
    }, ___EmotionJSX("p", null, payment.id, " - ", (_payment$partner = payment.partner) === null || _payment$partner === void 0 ? void 0 : _payment$partner.name), ___EmotionJSX("p", null, payment.total_report_amount, " ", payment.currency));
  })), ___EmotionJSX("div", {
    css: totalAmount
  }, ___EmotionJSX("p", null, ___EmotionJSX("strong", null, "\u041E\u0431\u0449\u0430 \u0441\u0443\u043C\u0430:")), ___EmotionJSX("p", null, totalSum.toFixed(2), " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
    value: totalSum,
    fromCurrency: currency
  }))), ___EmotionJSX("div", {
    css: function css(t) {
      return t.displayFlex({
        justify: 'flex-end'
      });
    }
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return modalRef.current.close();
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
    onClick: onConfirm
  }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438"))));
};

ReportPaymentsModal.propTypes = {
  modalRef: PropTypes.object,
  selectedPayments: PropTypes.array,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func
};
export default ReportPaymentsModal;